import { createSelector } from 'reselect'

const selectCheckoutSeatSelectionsByKey = (state: App.State) => state.checkout.form.flightSeatSelections ?? {}
const selectFlightsSeatSelectionsByKey = (state: App.State) => state.flights.seatSelections ?? {}

export const getFlightSeatSelectionsByKey = createSelector(
  [selectCheckoutSeatSelectionsByKey, selectFlightsSeatSelectionsByKey],
  (checkoutSeatSelections, flightSeatSelections): Record<string, Record<string, Record<string, App.FlightsSeatsItem>>> => ({
    ...checkoutSeatSelections,
    ...flightSeatSelections,
  }),
)

export const hasAnyFlightSeatsSelected = createSelector(
  [getFlightSeatSelectionsByKey],
  (seatSelectionsByKey): boolean => Object.values(seatSelectionsByKey).some(
    segmentSeats => Object.values(segmentSeats).some(
      travellerSeats => Object.keys(travellerSeats).length > 0,
    ),
  ),
)
